import styled from 'styled-components'

export const Tag = styled.span`
  border: 1px solid var(--red);
  background-color: var(--red-darker);
  height: 1.5rem;

  svg {
    width: 0.875rem;
    margin-right: var(--spacer-1);
  }
`

Tag.displayName = 'Tag'
